var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 31,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#close-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B2985F",
  d: "m24.499 8.35-1.285-1.285-15.429 15.43 1.285 1.284 15.429-15.43Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m14.858 12.852-5.78-5.78L7.79 8.357l5.781 5.781 1.286-1.286ZM24.506 22.5l-5.775-5.774-1.286 1.286 5.775 5.774 1.286-1.285Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m16.149 0 15.429 15.43-15.43 15.428L.72 15.43z"
})))));
export default SvgCloseIcon;